import { render, staticRenderFns } from "./NodeInspector.vue?vue&type=template&id=ada4f2ba&scoped=true"
import script from "./NodeInspector.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeInspector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NodeInspector.vue?vue&type=style&index=0&id=ada4f2ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada4f2ba",
  null
  
)

export default component.exports